import * as actionTypes from "./actionTypes"

export const change_language = (language) => {
    return dispatch => {
        dispatch({ type: actionTypes.SET_TRANSLATIONS, language: language })
    }
}